import {AppEntities} from "../../../config/entities";
import {NFLookupCatalog} from "./NFLookupCatalog";
import {NFLookupCatalogColumn} from "./NFLookupCatalogColumn";
import React from "react";
import {NFLookupDocument} from "./NFLookupDocument";

interface IProps {
    title?: string;
    fieldName: string;
    required?: boolean;
    showBorder?: boolean;
    selectedCatalog?: boolean;
    modelField?: string;
    setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupVendorInvoice = ({
                                          title,
                                          fieldName,
                                          required,
                                          showBorder,
                                          selectedCatalog,
                                          modelField,
                                          setSelectedCatalog,
                                      }: IProps) => {
    const loadData = async (searchText: string | undefined) => {
        return await AppEntities.VendorInvoices.getDataService().GetAll(searchText);
    };

    return (
        <>
            <NFLookupDocument
                fieldName={fieldName}
                title={title}
                entity={AppEntities.VendorInvoices}
                serverData={loadData}
                required={required}
                showBorder={showBorder}
                selectedCatalog={selectedCatalog}
                setSelectedCatalog={setSelectedCatalog}
            >
                <NFLookupCatalogColumn fieldName={"id"} caption={"Id"}/>
                {/* <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} /> */}
                <NFLookupCatalogColumn
                    fieldName={"documentNumber"}
                    caption={"documentNumber"}
                />
                {/* <NFLookupCatalogColumn fieldName={"tin"} caption={"TIN"} /> */}
            </NFLookupDocument>
        </>
    );
};
